import { IFormInputSpecNumberOfMeasurements } from 'pages/revisions-module/template-editor/editors/form/types';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { RevisionFieldProps } from 'components/forms/revision/fill-out/types';
import { NumberInput } from '@mantine/core';
import { useEffect, useMemo } from 'react';

/**
 * Custom predefined data input for the revision form.
 */
export default function RevisionFieldNumberOfMeasurements({
  spec,
  name,
  deviceId = 0,
}: RevisionFieldProps<IFormInputSpecNumberOfMeasurements>) {
  const { form } = useFillOutRevisionDataProvider();

  const length = useMemo(
    () => form.values.devices[deviceId]?.measurements[spec.sectionId]?.length || 0,
    [form.values, deviceId, spec.sectionId]
  );

  useEffect(() => {
    const { value: currentValue } = form.getInputProps(name);

    if (currentValue !== length) {
      form.setFieldValue(name, length);
    }
  }, [form, name, length]);

  return (
    <NumberInput
      size="lg"
      required={spec.required}
      readOnly
      label={spec.label}
      hideControls
      {...form.getInputProps(name)}
    />
  );
}
